export const DEFAULT_TIME_ZONE = 'UTC';

const FALLBACK_TIME_ZONE_OPTIONS = [
	'UTC',
	'America/Toronto',
	'America/New_York',
	'America/Chicago',
	'America/Denver',
	'America/Los_Angeles',
	'Europe/London',
	'Europe/Paris',
	'Asia/Tokyo',
	'Asia/Shanghai',
	'Australia/Sydney'
];

export const normalizeTimeZone = (value: unknown): string => {
	const timeZone = typeof value === 'string' ? value.trim() : '';
	if (!timeZone) {
		return '';
	}

	try {
		new Intl.DateTimeFormat('en-US', { timeZone }).format(new Date(0));
		return timeZone;
	} catch {
		return '';
	}
};

export const getBrowserTimeZone = (): string => {
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return normalizeTimeZone(timeZone);
};

export const getDisplayTimeZone = (...values: unknown[]): string => {
	for (const value of values) {
		const timeZone = normalizeTimeZone(value);
		if (timeZone) {
			return timeZone;
		}
	}

	return getBrowserTimeZone() || DEFAULT_TIME_ZONE;
};

export const formatTimeZoneLabel = (timeZone: string): string => timeZone.replaceAll('_', ' ');

export const makeTimeZoneOptions = (...preferred: unknown[]): string[] => {
	const supportedValuesOf = (
		Intl as unknown as {
			supportedValuesOf?: (key: 'timeZone') => string[];
		}
	).supportedValuesOf;
	const supportedTimeZones =
		typeof supportedValuesOf === 'function' ? supportedValuesOf('timeZone') : [];
	const values = [
		...preferred,
		getBrowserTimeZone(),
		DEFAULT_TIME_ZONE,
		...(supportedTimeZones.length > 0 ? supportedTimeZones : FALLBACK_TIME_ZONE_OPTIONS)
	];
	const seen = new Set<string>();
	const options: string[] = [];

	for (const value of values) {
		const timeZone = normalizeTimeZone(value);
		if (timeZone && !seen.has(timeZone)) {
			seen.add(timeZone);
			options.push(timeZone);
		}
	}

	return options;
};
